<template>
    <header class="landing-header" :class="[ isHidden ? 'hidden' : '' ]">
        <div class="header-left">
            <side-menu-toggler />
        </div>
        <div class="header-body">
            <transition name="stock-info">
                <stock-info class="d-none d-xl-block" v-if="isHome" />
            </transition>
            <div class="header-body-container">
                <router-link class="ruyi-logo align-self-center" :to="{ name: `${$i18n.locale}.home` }">
                    <img src="~@/assets/images/logos/ruyi.svg">
                </router-link>
                <transition name="go-back-button">
                    <button class="go-back-button d-none d-xl-block" @click="goBack()" v-if="!isHome">
                        <img src="~@/assets/images/arrow-left.svg">
                    </button>
                </transition>
                <div class="links d-none d-md-flex justify-content-end">
                    <site-nav />
                    <language-switcher />
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    import { mapActions, mapGetters, mapState } from 'vuex'

    import LanguageSwitcher from './LandingHeader/LanguageSwitcher'
    import SideMenuToggler from './LandingHeader/SideMenuToggler'
    import SiteNav from './LandingHeader/SiteNav'
    import StockInfo from './StockInfo'

    const scrollDelta = 10

    export default {
      data () {
        return {
          threshold: 0,
          lastScrollY: 0,
          isScrolling: false
        }
      },
      computed: {
        ...mapState({
          isHidden: (state) => state.landingHeader.isHidden,
          isSideMenuOpen: (state) => state.sideMenu.isOpen
        }),
        ...mapGetters([
          'isHome',
          'hasOverlays'
        ])
      },
      methods: {
        goBack () {
          this.$router.go(-1)
        },
        autoHide (e) {
          let currentScrollY = this.getScrollY()

          if (!this.isSideMenuOpen && !this.hasOverlays) {
            if (this.lastScrollY - currentScrollY > scrollDelta) {
              this.show()
            } else if (currentScrollY - this.lastScrollY > scrollDelta && currentScrollY > this.threshold) {
              this.hide()
            }
          }

          this.lastScrollY = currentScrollY
          this.isScrolling = false
        },
        getScrollY () {
          return (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
        },
        updateThreshold () {
          this.threshold = this.$el.clientHeight
        },
        ...mapActions({
          show: 'showHeader',
          hide: 'hideHeader'
        })
      },
      mounted () {
        this.updateThreshold()

        window.addEventListener('scroll', () => {
          if (this.isScrolling) {
            return
          }

          this.isScrolling = true

          requestAnimationFrame(this.autoHide)
        }, {passive: true})

        window.addEventListener('resize', () => {
          requestAnimationFrame(this.updateThreshold)
        }, {passive: true})
      },
      components: {
        LanguageSwitcher,
        SideMenuToggler,
        SiteNav,
        StockInfo
      }
    }
</script>

<style lang="scss">
    @import '~@/assets/styles/app';

    .landing-header {
        height: 0;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 100;

        .header-left {
            align-items: center;
            background-color: $white;
            display: flex;
            height: px2rem(70px);
            justify-content: center;
            position: absolute;
            top: 0;
            width: px2rem(70px);
            z-index: 100;

            @include media-breakpoint-up(xl) {
                height: px2rem(110px);
                width: px2rem(110px);
            }
        }

        .header-body {
            background-color: $white;
            display: flex;
            height: px2rem(70px);
            transition: transform .5s ease-in-out;

            @include media-breakpoint-up(xl) {
                height: px2rem(110px);
            }

            &-container {
                display: flex;
                height: 100%;
                margin-left: auto;
                position: relative;
                transition: width 1s ease-in-out;
                width: 50%;

                .landing-layout:not(.is-home) & {
                    @include media-breakpoint-up(xl) {
                        width: calc(100% - 275px);
                    }
                }
            }
        }

        .stock-info {
            align-self: center;
            font-size: px2rem(14px);
            margin-left: px2rem(150px);

            &-enter {
                &-active {
                    position: absolute;
                    opacity: 0;
                    transition: opacity .2s ease-in-out .3s;
                }
                &-to {
                    opacity: 1;
                }
            }

            &-leave {
                &-active {
                    opacity: 1;
                    position: absolute;
                    transition: opacity .2s ease-in-out;
                }
                &-to {
                    opacity: 0;
                }
            }
        }

        .ruyi-logo {
            display: block;
            transform: translateX(-50%);

            > img {
                width: px2rem(45px);

                @include media-breakpoint-up(xl) {
                    width: px2rem(70px);
                }

            }
        }

        .go-back-button {
            left: -110px;
            padding: 0.5rem;
            position: absolute;
            top: px2rem(30px);
            transform: translateX(-50%);

            > img {
                display: block;
            }

            &-enter {
                &-active {
                    left: 0;
                    opacity: 0;
                    position: absolute;
                    transition: opacity .5s ease-in-out .8s, left .5s ease-in-out .8s;
                    @include accelerate(opacity)
                }
                &-to {
                    opacity: 1;
                    left: -110px;
                }
            }
        }

        .links {
            font-size: px2rem(16px);
            margin-left: auto;

            .link {
                align-self: center;
                color: $dark-grey;
                padding: 0.5rem;

                @include hover-focus-active {
                    color: #d04a62;
                }

                &.active,
                &.exact-active {
                    color: #d04a62;
                }
            }
        }

        &.hidden {
            .header-body {
                transform: translateY(-100%);

                &-container {
                    transition-delay: .5s;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// LandingHeader.vue?7ad734d0